import { styled } from '@mui/material';

export const PieChartWrapper = styled('div')(({ theme, width, height }) => ({
  width     : width || '174px',
  height    : height || '174px',
  '& > div' : {},
}));

export const Container = styled('div')(({ theme }) => ({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  '& >div'       : {
    flex : '1',
  },
}));

export const Legend = styled('div')({
  '& >div' : {
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    marginTop      : '12px',
    marginBottom   : '24px',
    '& svg'        : {
      marginRight : '8px',
      color       : '#BABABA',
    },
  },
});

export const GraphWrapper = styled('div')(({ isVisible }) => ({
  display : isVisible ? 'block' : 'none',
}));
